module.exports = __webpack_public_path__ + "fonts/display-light.35df13de.woff2";